import * as Yup from "yup";
const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/webp",
];
const MAX_FILE_SIZE = 3;
export const formSchemaa = Yup.object().shape({
  status_id: Yup.number()
    .typeError("status type is required")
    .required("status is required"),
  description: Yup.string().min(100).required("description type is required"),
  address: Yup.string().required("address type is required"),
  total_area: Yup.number()
    .typeError("Total area must be a number")
    .required("total area type is required"),
  net_area: Yup.number()
    .typeError("net area must be a number")
    .required("net area type is required"),
  price: Yup.string().required("price type is required"),
  building_number: Yup.string().required("building number type is required"),
  direction_id: Yup.number()
    .typeError("Direction is required")
    .required("Direction is required"),
  contract_id: Yup.number()
    .typeError("post type is required")
    .required("post type is required"),
  city_id: Yup.number()
    .typeError("city type is required")
    .required("city is required"),
  category_id: Yup.number()
    .typeError("Category is required")
    .required("Category is required"),
  offertype_id: Yup.number()
    .typeError("offer type is required")
    .required("offer is required"),
  condition_id: Yup.number()
    .typeError("condition type is required")
    .required("condition is required"),
  furnishing_id: Yup.number()
    .typeError("furnishing type is required")
    .required("furnishing is required"),
  floor_id: Yup.number()
    .typeError("floor is required")
    .required("floor is required"),
  floor_number: Yup.number()
    .typeError("floor is required")
    .required("floor is required"),
  seller_id: Yup.number()
    .typeError("seller is required")
    .required("seller is required"),
  rent_id: Yup.number()
    .typeError("rent is required")
    .required("rent is required"),
  car_model_id: Yup.number()
    .typeError("car brand is required")
    .required("car brand is required"),
  car_submodel: Yup.string().min(2)
    .typeError("car model is required")
    .required("car model is required"),
  car_status_id: Yup.number()
    .typeError("car situation is required")
    .required("car situation is required"),
  made_year: Yup.number()
    .typeError("car made year is required")
    .required("car made year is required"),
  color_id: Yup.number()
    .typeError("car color is required")
    .required("car color is required"),
  paintcondition_id: Yup.number()
    .typeError("car paint condition is required")
    .required("car paint condition is required"),
  car_transmission_id: Yup.number()
    .typeError("car transmission is required")
    .required("car transmission is required"),
  motor_counter: Yup.number()
    .typeError("motor counter is required")
    .required("motor counter is required"),
  motorsize: Yup.number()
    .typeError("motor capacity is required")
    .required("motor capacity is required"),
  motordrive_id: Yup.number()
    .typeError("motor drive is required")
    .required("motor drive is required"),
  carchair_id: Yup.number()
    .typeError("car chair type is required")
    .required("car chair type is required"),
  petroltype_id: Yup.number()
    .typeError("car petrol type is required")
    .required("car petrol type is required"),
  images: Yup.array()
    .test("min-images", function (value) {
      const count = value ? value.length : 0;

      if (count === 0)
        return this.createError({ message: "You must upload 3 images" });
      if (count < 3)
        return this.createError({
          message: `You uploaded ${count}, please upload ${3 - count} more`,
        });
      if (count > 10)
        return this.createError({ message: "You uploaded more than 3 images" });

      return true;
    })
    .typeError("Images are required")
    .required("Images are required"),
  unit_image: Yup.mixed()
    .required("يرجى تحميل صورة")
    .test("fileExists", "يرجى تحميل صورة", (value) => {
      return value instanceof File;
    })
    .test("fileSize", "الصورة كبيرة جدًا (أقصى حد 2MB)", (value) => {
      return value && value.size <= 2 * 1024 * 1024;
    })
    .test("fileType", "الصيغة غير مدعومة", (value) => {
      return (
        value &&
        value.type &&
        ["image/jpg", "image/jpeg", "image/png"].includes(value.type.toLowerCase())
      );
    })

  ,
  "car-image": Yup.object()
    .typeError("Image is required")
    .required("Image is required"),
});
export const validationSchema = Yup.object().shape({
  project_name: Yup.string()
    .required("Project name is required")
    .min(3, "Project name must be at least 3 characters"),

  project_name_en: Yup.string()
    .required("Project name (EN) is required")
    .min(3, "Project name (EN) must be at least 3 characters"),

  address: Yup.string()
    .required("Address is required"),

  project_description: Yup.string()
    .required("Project description is required")
    .min(10, "Description must be at least 10 characters"),

  project_description_en: Yup.string()
    .required("Project description (EN) is required")
    .min(10, "Description (EN) must be at least 10 characters"),

  progress: Yup.number()
    .required("Progress is required")
    .min(0, "Progress must be between 0 and 100")
    .max(100, "Progress must be between 0 and 100"),

  floors_count: Yup.number()
    .required("Floors count is required")
    .positive("Floors must be a positive number")
    .integer("Floors must be an integer"),


});



export const formSchemaregister = Yup.object().shape({
  fullname: Yup.string()
    .min(4, "Full name must be at least 4 characters")
    .max(100, "Full name must be at most 100 characters")
    .required("Full name is required"),

  mobile: Yup.string()
    .matches(/^\d+$/, "Mobile must contain only digits")
    .min(10, "Mobile number is too short")
    .required("Mobile is required"),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),

  password_confirmation: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Password confirmation is required"),
});


export const formdeveloperSchemaa = Yup.object().shape({
  developer_name: Yup.string()
    .required("developer name is required"),

  developer_name_en: Yup.string()
    .required("developer name is required"),

  developer_address: Yup.string()
    .required("developer address is required"),

  developer_description: Yup.string()
    .required("description is required"),
 
    
    developer_address_en: Yup.string()
    .required("developer address is required"),
    developer_email: Yup.string()
    .required("email is required"),
  developer_phone: Yup.string()
    .matches(/^\d+$/, "Mobile must contain only digits")
    .min(10, "Mobile number is too short")
    .required("Mobile is required"),

// developer_image: Yup.object()
//     .typeError("Image is required")
//     .required("Image is required"),
});